import {
  FormHandler,
  FormItem,
  MenuPresets,
  RelationEditor,
  TextInput,
} from '@framework/form';
import { Drawer } from '@framework/ui';
import { Button, ButtonProps, Collapse, message } from 'antd';
import { BooleanConditionEditorInput } from '../../../../../../inputs/expressions-editor/conditions/BooleanConditionEditorInput';
import { RichTextAdvancedInput } from '../../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { DrawerEditorButtonRow } from '../../../../../../ui/drawer';
import { StyledDrawerCollapse } from '../../../../../../ui/drawer/StyledDrawerCollapse';
import { IWidgetOption } from '../../../../Widget';
import { createDefaultOptionValue } from './util/createDefaultOptionValue';
import { widgetOptionValueValidator } from './util/widgetOptionValidator';

const { Panel } = Collapse;

export interface IWidgetOptionValueEditDrawerProps {
  editor: RelationEditor<IWidgetOption>;
  buttonProps?: Omit<ButtonProps, 'onClick'>;
  index: number | null;
  setIndex: (index: number | null) => void;
}

export function WidgetOptionValueEditDrawer(
  props: IWidgetOptionValueEditDrawerProps,
) {
  const { editor, buttonProps, index, setIndex } = props;

  return (
    <>
      <Button
        children="+ Opzione"
        {...buttonProps}
        onClick={() => {
          setIndex(null);
          editor.handle.open(createDefaultOptionValue());
        }}
      />
      <Drawer
        maskClosable={false}
        title="Configurazione opzione"
        size="large"
        placement="right"
        onClose={editor.handle.cancel}
        open={
          editor.handle.isVisible && editor.handle.current?.type === 'option'
        }
        destroyOnClose
      >
        <FormHandler
          layout="vertical"
          schema={widgetOptionValueValidator}
          initialValues={
            editor.handle.current ??
            widgetOptionValueValidator.cast({}, { assert: false })
          }
          onSubmit={async rawValues => {
            try {
              const values = await widgetOptionValueValidator.validate(
                rawValues,
              );

              const type = editor.handle.apply(values, index);

              if (type === 'updated') {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                message.success('Opzione modificata');
              } else {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                message.success('Opzione aggiunta');
              }
            } catch (e) {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              message.error('Si è verificato un errore nella gestione dell\'opzione'); // prettier-ignore
              console.error(e);
            }
          }}
        >
          <FormItem name="label" label="Etichetta">
            <RichTextAdvancedInput
              rows={4}
              name="label"
              menus={MenuPresets.InlineWithAlign}
            />
          </FormItem>
          <FormItem name="value" label="Valore">
            <TextInput name="value" />
          </FormItem>

          <StyledDrawerCollapse defaultActiveKey={['view']} ghost>
            <Panel header="Regole di Visualizzazione" key="view">
              <FormItem name="visible" label="Visibilità">
                <BooleanConditionEditorInput name="visible" label="Visibile" />
              </FormItem>
              <FormItem name="enabled" label="Abilitato">
                <BooleanConditionEditorInput name="enabled" label="Abilitato" />
              </FormItem>
            </Panel>
          </StyledDrawerCollapse>

          <DrawerEditorButtonRow editor={editor} />
        </FormHandler>
      </Drawer>
    </>
  );
}
